document.addEventListener("DOMContentLoaded", function () {
  var show360Button = document.querySelector(".show360");
  var close360Button = document.querySelector("#post-508 .ct-toggle-close");

  if (show360Button) {
    show360Button.addEventListener("click", function () {
      add360View("show360");
    });
    close360Button.addEventListener("click", function () {
      window.CI360.destroy();
    });
  }
});

function add360View(viewId) {
  const new360View = document.getElementById(viewId);
  new360View.classList.add("cloudimage-360");
  window.CI360.add(viewId);
}
